/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Slug_jobbannonse_QueryVariables = {
    slug: string;
};
export type Slug_jobbannonse_QueryResponse = {
    readonly joblisting: {
        readonly title: string;
        readonly description: string | null;
        readonly sharingImage: string | null;
        readonly company: {
            readonly description: string;
            readonly name: string;
        };
        readonly " $fragmentRefs": FragmentRefs<"JoblistingView_joblisting">;
    } | null;
};
export type Slug_jobbannonse_Query = {
    readonly response: Slug_jobbannonse_QueryResponse;
    readonly variables: Slug_jobbannonse_QueryVariables;
};



/*
query Slug_jobbannonse_Query(
  $slug: String!
) {
  joblisting(slug: $slug) {
    ...JoblistingView_joblisting
    title
    description
    sharingImage
    company {
      description
      name
      id
    }
    id
  }
}

fragment JoblistingView_joblisting on Joblisting {
  id
  company {
    name
    logo(width: 1127, height: 260)
    description
    url
    id
  }
  towns {
    name
    id
  }
  image
  deadline
  title
  type
  description
  fromGrade
  toGrade
  url
  dateCreated
  videoUrl
  isActive
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharingImage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Slug_jobbannonse_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Joblisting",
        "kind": "LinkedField",
        "name": "joblisting",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "JoblistingView_joblisting"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Slug_jobbannonse_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Joblisting",
        "kind": "LinkedField",
        "name": "joblisting",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 260
                  },
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 1127
                  }
                ],
                "kind": "ScalarField",
                "name": "logo",
                "storageKey": "logo(height:260,width:1127)"
              },
              (v3/*: any*/),
              (v7/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Town",
            "kind": "LinkedField",
            "name": "towns",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deadline",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromGrade",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toGrade",
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3c760b19c2571cb2c14c9e7c8f1bc90",
    "id": null,
    "metadata": {},
    "name": "Slug_jobbannonse_Query",
    "operationKind": "query",
    "text": "query Slug_jobbannonse_Query(\n  $slug: String!\n) {\n  joblisting(slug: $slug) {\n    ...JoblistingView_joblisting\n    title\n    description\n    sharingImage\n    company {\n      description\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment JoblistingView_joblisting on Joblisting {\n  id\n  company {\n    name\n    logo(width: 1127, height: 260)\n    description\n    url\n    id\n  }\n  towns {\n    name\n    id\n  }\n  image\n  deadline\n  title\n  type\n  description\n  fromGrade\n  toGrade\n  url\n  dateCreated\n  videoUrl\n  isActive\n}\n"
  }
};
})();
(node as any).hash = '2307bc6669914850d9eccfbe85fcbea6';
export default node;
